import Divider from 'components/divider/divider';
import StyledInput from 'components/styledInput/StyledInput';
import ToolProviderList from 'components/toolProviders/ToolProviderList';
import { missionToolsOf } from 'components/toolProviders/missionToolProviders';
import MissionDetailRow from './MissionDetailRow';
import { missionDetailText } from './missionDetailTexts';
import { DRESS_CODE_MAX_LENGTH } from './missionSheetFields';

/** Checkbox list of a referential, or the mission values when not editing. */
const RequirementField = ({
  isEditing,
  options,
  onChange,
  values,
  emptyLabel,
}) => {
  if (!isEditing) {
    return Array.isArray(values) && values.length > 0
      ? values.join(', ')
      : emptyLabel;
  }
  const checkedNames = options
    .filter((option) => option.checked === true)
    .map((option) => option.name);
  return (
    <StyledInput
      type={'selectMultipleCheckbox'}
      isSearchable
      value={checkedNames.length > 0 ? checkedNames.join(', ') : '-'}
      list={options.map((option) => ({
        value: option.name,
        label: option.name,
        checked: option.checked,
      }))}
      onChange={onChange}
    />
  );
};

/**
 * The tools with their provider. A provider the mission does not know
 * reads as the company; editing, the referential picks the tools and each row
 * switches its provider.
 */
const ToolsField = ({
  infoMission,
  isEditing,
  tools,
  onToolsChange,
  toolProviders,
  onToolProvidersChange,
}) => {
  const rows = isEditing ? toolProviders || [] : missionToolsOf(infoMission);
  return (
    <div className={'flex flex-col gap-2'}>
      <MissionDetailRow label={'Matériel'}>
        {isEditing ? (
          <RequirementField
            isEditing
            options={tools}
            onChange={onToolsChange}
          />
        ) : rows.length === 0 ? (
          'Aucun'
        ) : null}
      </MissionDetailRow>
      {rows.length > 0 && (
        <ToolProviderList
          tools={rows}
          readOnly={!isEditing}
          onChange={onToolProvidersChange}
        />
      )}
    </div>
  );
};

/**
 * « Pré-requis » sub-tab of the mission detail: licences, tools, languages,
 * dress code. The form state lives in adminMissionDetails.
 */
const MissionRequirementsTab = ({
  infoMission,
  isEditing,
  licences,
  onLicencesChange,
  tools,
  onToolsChange,
  languages,
  onLanguagesChange,
  toolProviders,
  onToolProvidersChange,
  dressCode,
  onDressCodeChange,
  dressCodeError,
}) => (
  <>
    <MissionDetailRow label={'Permis'}>
      <RequirementField
        isEditing={isEditing}
        options={licences}
        onChange={onLicencesChange}
        values={infoMission.licences}
        emptyLabel={'Aucun'}
      />
    </MissionDetailRow>
    <Divider />
    <ToolsField
      infoMission={infoMission}
      isEditing={isEditing}
      tools={tools}
      onToolsChange={onToolsChange}
      toolProviders={toolProviders}
      onToolProvidersChange={onToolProvidersChange}
    />
    <Divider />
    <MissionDetailRow label={'Langue'}>
      <RequirementField
        isEditing={isEditing}
        options={languages}
        onChange={onLanguagesChange}
        values={infoMission.language}
        emptyLabel={'Aucune'}
      />
    </MissionDetailRow>
    <Divider />
    <MissionDetailRow label={missionDetailText('requirements.dressCode')}>
      {isEditing ? (
        <StyledInput
          type={'textarea'}
          value={dressCode}
          // The limit is enforced by the error below, not by the browser,
          // which would silently cut a pasted text.
          maxLength={DRESS_CODE_MAX_LENGTH * 2}
          error={dressCodeError}
          onChange={(e) => onDressCodeChange(e.target.value)}
        />
      ) : (
        infoMission.dressCode ||
        missionDetailText('requirements.dressCodeEmpty')
      )}
    </MissionDetailRow>
    <Divider />
  </>
);

export default MissionRequirementsTab;
